/**
 * File: ca_ES.js
 * Project: Noname-Base-Frontend
 * File Created: Friday, 25th October 2024 11:40:16 am
 * Author: Daniel Rodríguez Cabrera (daniel.rodriguez@aerin.es)
 * Version: 2.0.0
 * -----
 * Last Modified: Monday, 4th August 2025 1:29:39 pm
 * Modified By: Alexandru Ionut Dascalu
 * -----
 * Copyright (c) 2023 - 2024 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 */

/* Textos de l'idioma Gogo

Taula de continguts

01.General
02.Inici de sessió, tancament de sessió, registre d'usuari
03.Menú
04.Panells de control
05.Pàgines
06.Aplicacions
  06.01.Xat
  06.02.Enquesta
  06.03.Tasques pendents
07.UI
  07.01.Alertes
  07.02.Insígnies
  07.03.Botons
  07.04.Targetes
  07.05.Carrusel
  07.06.Gràfics
  07.07.Contraure
  07.08.Menús desplegables
  07.09.Editors
  07.10.Formularis
  07.11.Components de formulari
  07.12.Icones
  07.13.Grups de camps d'entrada
  07.14.Jumbotron
  07.15.Modal
  07.16.Navegació
  07.17.Popover & Consell d'eina
  07.18.Ordenable
  07.19.Mapes
  07.20.Taules
  07.21.Assistents
  07.22.Errors
*/

module.exports = {
  /* 01.General */
  'general.copyright': 'Noname © 2022 Tots els drets reservats.',
  'general.project-name': 'NONAME',

  'unauthorized.title': 'Intent d’accés no autoritzat',
  'unauthorized.detail':
    'No està autoritzat per veure la pàgina a la qual intentes accedir.',

  /* 02.Inici de sessió d’usuari, tancament de sessió, registre */
  'user.login-title': 'Inicia sessió',
  'user.register': 'Registre',
  'user.forgot-password': 'Has oblidat la contrasenya?',
  'user.email': 'Correu electrònic',
  'user.password': 'Contrasenya',
  'user.forgot-password-question': 'Contrasenya oblidada?',
  'user.fullname': 'Nom complet',
  'user.login-button': 'INICIA SESSIÓ',
  'user.login-sso': 'Iniciar sessió amb SSO',
  'user.sso-redirecting': 'Redirigint...',
  'user.sso-authenticating': 'Autenticant...',
  'user.sso-error':
    "No s'ha pogut iniciar sessió amb SSO. Comprova que el teu usuari té accés a l'aplicació o inicia sessió amb usuari i contrasenya.",
  'user.sso-error-user-not-found':
    "El teu compte no està donat d'alta a l'aplicació. Contacta amb l'administrador perquè et doni accés.",
  'user.sso-error-inactive':
    "El teu usuari està desactivat. Contacta amb l'administrador.",
  'user.register-button': 'REGISTRE',
  'user.reset-password-button': 'REINICIA',
  'user.buy': 'COMPRAR',
  'user.username': "Nom d'usuari",
  'user.new-password-again': 'Nova contrasenya novament',
  'user.new-password': 'Nova contrasenya',
  'user.reset-password': 'Restablir contrasenya',
  'user.warning-message': 'Si us plau, usa les teves credencials per accedir.',
  'user.error.internal-server':
    'Error intern del servidor. Si us plau, torna-ho a intentar més tard.',
  'user.error.invalid-credentials':
    'Credencials no vàlides. Si us plau, comprova el teu nom d’usuari i contrasenya.',
  'user.error.generic':
    'S’ha produït un error. Si us plau, torna-ho a intentar.',
  'user.error.no-response':
    'No s’ha rebut resposta del servidor. Si us plau, comprova la teva connexió o torna-ho a intentar més tard.',
  'user.error.config-request':
    'S’ha produït un error en configurar la sol·licitud: ',
  'user.error.login': 'Error al iniciar sessió',
  'user.error.expired-token': 'El token de sessió ha caducat.',

  /* 03.Menu */
  'menu.home': 'Inici',
  'menu.app': 'Inici',
  'menu.dashboards': 'Taulers',
  'menu.default': 'Per defecte',
  'menu.analytics': 'Analítica',
  'menu.ecommerce': 'Comerç electrònic',
  'menu.content': 'Contingut',
  'menu.pages': 'Pàgines',
  'menu.administration': 'Administració',
  'menu.audits': 'Auditoria',
  'menu.accounts': 'Usuaris',
  'menu.data-list': 'Llista de dades',
  'menu.thumb-list': 'Llista amb miniatures',
  'menu.image-list': 'Llista d’imatges',
  'menu.details': 'Detalls',
  'menu.search': 'Cerca',
  'menu.login': 'Inicia sessió',
  'menu.register': 'Registre',
  'menu.forgot-password': 'He oblidat la contrasenya',
  'menu.reset-password': 'Restableix la contrasenya',
  'menu.error': 'Error',
  'menu.applications': 'Aplicacions',
  'menu.todo': 'Notes',
  'menu.survey': 'Enquesta',
  'menu.chat': 'Xat',
  'menu.ui': 'IU',
  'menu.alerts': 'Alertes',
  'menu.badges': 'Insígnies',
  'menu.buttons': 'Botons',
  'menu.cards': 'Targetes',
  'menu.carousel': 'Carrusel',
  'menu.charts': 'Gràfics',
  'menu.collapse': 'Col·lapse',
  'menu.dropdowns': 'Menús desplegables',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Disposicions de formulari',
  'menu.form-components': 'Components de formulari',
  'menu.form-validations': 'Validacions de formulari',
  'menu.form-wizard': 'Assistent de formulari',
  'menu.icons': 'Icones',
  'menu.input-groups': 'Grups d’entrada',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navegació',
  'menu.popover-tooltip': 'Tooltips i Popovers',
  'menu.sortable': 'Ordenable',
  'menu.tables': 'Taules',
  'menu.menu': 'Menú',
  'menu.subhidden': 'Sub ocult',
  'menu.hidden': 'Ocult',
  'menu.visible': 'Visible',
  'menu.maps': 'Mapes',
  'menu.landingpage': 'Pàgina de destinació',
  'menu.multipage-home': 'Multipàgina',
  'menu.singlepage-home': 'Un sol pàgina',
  'menu.about': 'Sobre',
  'menu.auth-login': 'Autenticació',
  'menu.auth-register': 'Registre',
  'menu.blog': 'Blog',
  'menu.blog-list': 'Llista del blog',
  'menu.blog-detail': 'Detall del blog',
  'menu.careers': 'Carreres',
  'menu.confirmation': 'Confirmació',
  'menu.contact': 'Contacte',
  'menu.docs': 'Docs',
  'menu.features': 'Característiques',
  'menu.prices': 'Preus',
  'menu.videos': 'Vídeos',
  'menu.mailing': 'Correu',
  'menu.invoice': 'Factura',
  'menu.blank-page': 'Pàgina en blanc',
  'menu.types': 'Tipus de menú',
  'menu.levels': 'Nivells de menú',
  'menu.third-level-1': 'Tercer nivell 1',
  'menu.third-level-2': 'Tercer nivell 2',
  'menu.third-level-3': 'Tercer nivell 3',
  'menu.faq': 'Preguntes freqüents',
  'menu.knowledge-base': 'Base de coneixement',
  'menu.authorization': 'Autorizació',
  'menu.profile': 'Perfil',
  'menu.product': 'Producte',
  'menu.miscellaneous': 'Divers',
  'menu.portfolio': 'Portafoli',
  'menu.social': 'Social',
  'menu.details-alt': 'Detalls alt',
  'menu.forms': 'Formularis',
  'menu.components': 'Components',
  'menu.layouts': 'Disposicions',
  'menu.validations': 'Validacions',
  'menu.wizard': 'Assistent',

  /* Administrative accounts */
  'administration.accounts.create': 'Crear',
  'administration.accounts.cancel': 'Cancel·lar',
  'administration.accounts.tittle.create': 'Crear nou usuari',
  'administration.accounts.username': 'Usuari',
  'administration.accounts.email': 'Correu electrònic',
  'administration.accounts.name': 'Nom',
  'administration.accounts.lastname': 'Cognom',
  'administration.accounts.password': 'Contrasenya',
  'administration.accounts.confirmpassword': 'Confirmar contrasenya',
  'administration.accounts.staff': 'Personal',
  'administration.accounts.administrator': 'Administrador',
  'administration.accounts.edit': 'Editar',
  'administration.accounts.delete': 'Eliminar',

  /* Administration audits */
  'administration.audits.criticality': 'Criticitat',
  'administration.audits.date': 'Data',
  'administration.audits.app': 'Aplicació',
  'administration.audits.application': 'Nom de l’aplicació',
  'administration.audits.message': 'Missatge',

  /* 04.Taulers */
  'dashboards.pending-orders': 'Comandes pendents',
  'dashboards.completed-orders': 'Comandes completades',
  'dashboards.refund-requests': 'Sol·licitud de reemborsament',
  'dashboards.new-comments': 'Nous comentaris',
  'dashboards.sales': 'Vendes',
  'dashboards.orders': 'Comandes',
  'dashboards.refunds': 'Reemborsament',
  'dashboards.recent-orders': 'Comandes recents',
  'dashboards.product-categories': 'Categories de producte',
  'dashboards.cakes': 'Pastissos',
  'dashboards.tickets': 'Entrades',
  'dashboards.calendar': 'Calendari',
  'dashboards.best-sellers': 'Els més venuts',
  'dashboards.website-visits': 'Visites al lloc web',
  'dashboards.unique-visitors': 'Visitants únics',
  'dashboards.this-week': 'Aquesta setmana',
  'dashboards.last-week': 'La setmana passada',
  'dashboards.this-month': 'Aquest mes',
  'dashboards.conversion-rates': 'Taxa de conversió',
  'dashboards.per-session': 'Per sessió',
  'dashboards.profile-status': 'Estat del perfil',
  'dashboards.payment-status': 'Estat del pagament',
  'dashboards.work-progress': 'Treball en curs',
  'dashboards.tasks-completed': 'Tasques completades',
  'dashboards.payments-done': 'Pagaments realitzats',
  'dashboards.order-stock': 'Comandes - Valors',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Publicació ràpida',
  'dashboards.title': 'Títol',
  'dashboards.content': 'Contingut',
  'dashboards.category': 'Categoria',
  'dashboards.save-and-publish': 'Desa i publica',
  'dashboards.top-viewed-posts': 'Publicacions més vistes',
  'dashboards.posts': 'Entrades',
  'dashboards.pending-for-publish': 'Pendent de publicació',
  'dashboards.users': 'Usuaris',
  'dashboards.on-approval-process': "En procés d'aprovació",
  'dashboards.alerts': 'Alertes',
  'dashboards.waiting-for-notice': 'Esperant avís',
  'dashboards.files': 'Fitxers',
  'dashboards.pending-for-print': 'Pendent d’impressió',
  'dashboards.logs': 'Registres',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'LA MÀGIA ESTÀ EN ELS DETALLS',
  'dashboards.yes-it-is-indeed': 'Sí, és cert!',
  'dashboards.advanced-search': 'Cerca avançada',
  'dashboards.toppings': 'Cobertures',
  'dashboards.type': 'Categoria',
  'dashboards.keyword': 'Paraula clau',
  'dashboards.search': 'Cerca',
  'dashboards.top-rated-items': 'Articles més ben valorats',

  /* 05.Esquemes */
  'pages.add-new': 'AFEGIR NOU',
  'pages.add-new-modal-title': 'Afegir un nou element',
  'pages.display-options': 'Opcions de visualització',
  'pages.orderby': 'Ordenar per : ',
  'pages.total': 'Total: ',
  'pages.viewing': 'Visualitzant : ',
  'pages.product-name': 'Nom del producte',
  'pages.category': 'Categoria',
  'pages.description': 'Descripció',
  'pages.status': 'Estat',
  'pages.cancel': 'Cancel·lar',
  'pages.submit': 'Enviar',
  'pages.delete': 'Esborrar',
  'pages.another-action': 'Una altra acció',
  'pages.actions': 'ACCIONS',
  'pages.header': 'Capçalera',
  'pages.details': 'DETALLS',
  'pages.orders': 'COMANDES',
  'pages.rating': 'Valoració',
  'pages.price': 'Preu',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'És vegà',
  'pages.order-status': 'Estat de la comanda',
  'pages.bake-progress': 'Procés de cocció',
  'pages.popularity': 'Popularitat',
  'pages.comments': 'Comentaris',
  'pages.error-title': 'Vaja, sembla que hi ha hagut un error!',
  'pages.error-code': 'Codi d’error',
  'pages.go-back-home': 'TORNA A L’INICI',
  'pages.mailing-info':
    'Les plantilles de correu fan servir disseny en línia i estructura en taules per mostrar-se correctament a diversos serveis. Per millorar la usabilitat, s’inclouen com a HTML normal amb dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'La plantilla de factura té una versió amb estil en línia per a ús fora del projecte, així com la versió React.',
  'pages.react-version': 'Versió React',
  'pages.inline-version': 'Versió HTML en línia',
  'pages.like': 'M’agrada',
  'pages.likes': 'M’agrada',
  'pages.details-title': 'Detalls',
  'pages.comments-title': 'Comentaris',
  'pages.questions-title': 'Preguntes',
  'pages.similar-projects': 'Projectes similars',
  'pages.send': 'Enviar',
  'pages.addComment': 'Afegeix un comentari',
  'pages.location': 'Ubicació',
  'pages.responsibilities': 'Responsabilitats',
  'pages.photos': 'Fotos',
  'pages.who-to-follow': 'A qui seguir',
  'pages.follow': 'SEGUEIX',
  'pages.followers': 'SEGUIDORS',
  'pages.recent-posts': 'Missatges recents',
  'pages.profile': 'PERFIL',
  'pages.friends': 'AMICS',
  'pages.images': 'IMATGES',
  'pages.purchase': 'COMPRA',
  'pages.price.developer': 'DESENVOLUPADOR',
  'pages.price.team': 'EQUIP',
  'pages.price.enterprise': 'EMPRESA',
  'pages.price.twofactorauthentication': 'Autenticació en dos passos',
  'pages.price.teampermissions': "Permisos de l'equip",
  'pages.price.245Support': 'Suport 24/5',
  'pages.price.247Support': 'Suport 24/7',
  'pages.price.useractionsauditlog': "Registre d'accions de l'usuari",
  'pages.prices.featurecomparison': 'Comparació de funcionalitats',
  'pages.prices.pricecomparison': 'Comparació de preus',

  /* 06.Aplicacions */

  /* 06.01.Xat */
  'chat.messages': 'Missatges',
  'chat.contacts': 'Contactes',
  'chat.saysomething': 'Digues alguna cosa...',

  /* 06.02.Enquesta */
  'survey.delete': 'Esborra',
  'survey.edit': 'Edita',
  'survey.add-new': 'AFEGIR NOU',
  'survey.add-new-title': 'Afegeix nova enquesta',
  'survey.title': 'Títol',
  'survey.category': 'Categoria',
  'survey.label': 'Etiqueta',
  'survey.status': 'Estat',
  'survey.cancel': 'Cancel·la',
  'survey.submit': 'Envia',
  'survey.another-action': 'Una altra acció',
  'survey.display-options': 'Opcions de visualització',
  'survey.orderby': 'Ordena per: ',
  'survey.all-surveys': 'Totes les enquestes',
  'survey.completed-surveys': 'Enquestes completades',
  'survey.categories': 'Categories',
  'survey.active-surveys': 'Enquestes actives',
  'survey.labels': 'Etiquetes',

  /* 06.03.Notes */
  'todo.add-new': 'AFEGIR NOU',
  'todo.add-new-title': 'Afegeix nou',
  'todo.title': 'Títol',
  'todo.detail': 'Detall',
  'todo.category': 'Categoria',
  'todo.label': 'Etiqueta',
  'todo.status': 'Estat',
  'todo.cancel': 'Cancel·la',
  'todo.submit': 'Envia',
  'todo.action': 'Acció',
  'todo.another-action': 'Una altra acció',
  'todo.display-options': 'Opcions de visualització',
  'todo.orderby': 'Ordena per: ',
  'todo.all-tasks': 'Totes les tasques',
  'todo.pending-tasks': 'Tasques pendents',
  'todo.completed-tasks': 'Tasques completades',
  'todo.categories': 'Categories',
  'todo.labels': 'Etiquetes',

  /* 07.IU */

  /* 07.01.Alertes */
  'alert.rounded': 'Alerta arrodonida',
  'alert.react-notifications': 'Notificacions React',
  'alert.outline': 'Contorn',
  'alert.primary': 'Principal',
  'alert.secondary': 'Secundari',
  'alert.info': 'Informació',
  'alert.success': 'Èxit',
  'alert.warning': 'Avís',
  'alert.error': 'Error',
  'alert.filled': 'Ple',
  'alert.primary-text': 'Això és una alerta principal—comprova-ho!',
  'alert.secondary-text': 'Això és una alerta secundària—comprova-ho!',
  'alert.success-text': 'Això és una alerta d’èxit—comprova-ho!',
  'alert.danger-text': 'Això és una alerta de perill—comprova-ho!',
  'alert.warning-text': 'Això és una alerta d’avís—comprova-ho!',
  'alert.info-text': 'Això és una alerta informativa—comprova-ho!',
  'alert.light-text': 'Això és una alerta lleugera—comprova-ho!',
  'alert.dark-text': 'Això és una alerta fosca—comprova-ho!',
  'alert.default': 'Alerta per defecte',
  'alert.dismissing': 'Alerta amb tancament',
  'alert.dismissing-text':
    'Caram! Hauries de revisar alguns d’aquests camps a continuació.',
  'alert.dismissing-without-animate-text':
    'Estic alerta i es pot tancar sense animació!',

  /* 07.02.Insígnies */
  'badge.sizes': 'Mides',
  'badge.colors': 'Colors',
  'badge.outline': 'Contorn',
  'badge.links': 'Enllaços',
  'badge.counter-badges': 'Comptadors d’insígnies',
  'badge.bootstrap-default': 'Bootstrap per defecte',
  'badge.primary': 'Principal',
  'badge.secondary': 'Secundari',
  'badge.success': 'Èxit',
  'badge.danger': 'Perill',
  'badge.warning': 'Avís',
  'badge.info': 'Informació',
  'badge.light': 'Lleuger',
  'badge.dark': 'Fosc',

  /* 07.03.Botons */
  'button.default': 'Bootstrap per defecte',
  'button.colors': 'Colors',
  'button.rounded': 'Botons arrodonits',
  'button.outline': 'Contorn',
  'button.states': 'Estats',
  'button.sizes': 'Mides',
  'button.button-groups': 'Grups de botons',
  'button.large-button': 'Botó gran',
  'button.small-button': 'Botó petit',
  'button.extra-small-button': 'Botó extra petit',
  'button.block-button': 'Botó bloc',
  'button.active': 'Actiu',
  'button.disabled': 'Desactivat',
  'button.basic': 'Bàsic',
  'button.toolbar': 'Barra d’eines',
  'button.nesting': 'Annidament',
  'button.vertical-variation': 'Variació vertical',
  'button.checkbox-radio-button': 'Checkbox i botons de ràdio',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Ràdio',
  'button.radio-button': 'Botó de ràdio',
  'button.primary': 'Principal',
  'button.secondary': 'Secundari',
  'button.success': 'Èxit',
  'button.danger': 'Perill',
  'button.warning': 'Avís',
  'button.info': 'Informació',
  'button.light': 'Lleuger',
  'button.dark': 'Fosc',
  'button.states-text':
    'Aquest botó mostra una roda giratòria durant 2 segons i una icona d’error durant 3 segons abans de tornar a l’estat normal. Aquests estats es poden activar afegint i traient classes.',
  'button.click-here': 'Fes clic aquí',
  'button.states-text-alternate':
    'Aquest botó mostra una roda giratòria durant 2 segons i una icona d’error durant 3 segons abans de tornar a l’estat normal. Aquests estats es poden activar afegint i traient classes.',
  'button.primary-link': 'Enllaç principal',
  'button.link': 'Enllaç',
  'button.primary-button': 'Botó principal',
  'button.button': 'Botó',
  'button.left': 'Esquerra',
  'button.middle': 'Centre',
  'button.right': 'Dreta',
  'button.dropdown': 'Desplegable',
  'button.dropdown-link': 'Enllaç desplegable',

  /* 07.04.Targetes */
  'cards.icon-card': 'Targeta amb icona',
  'cards.image-card': 'Targeta amb imatge',
  'cards.image-overlay-card': 'Targeta amb superposició d’imatge',
  'cards.image-card-list': 'Llista de targetes amb imatge',
  'cards.tab-card': 'Targeta amb pestanya',
  'cards.user-card': 'Targeta d’usuari',

  /* 07.05.Carrusel */
  'carousel.basic': 'Carrusel bàsic',
  'carousel.single': 'Carrusel senzill',
  'carousel.without-controls': 'Carrusel sense controls',

  /* 07.06.Gràfics */
  'charts.line': 'Gràfic de línia',
  'charts.polar': 'Gràfic polar',
  'charts.area': 'Gràfic d’àrea',
  'charts.scatter': 'Gràfic de dispersió',
  'charts.bar': 'Gràfic de barres',
  'charts.radar': 'Gràfic de radar',
  'charts.pie': 'Gràfic circular',
  'charts.doughnut': 'Gràfic d’anella',
  'charts.shadow': 'Ombra',
  'charts.no-shadow': 'Sense ombra',

  /* 07.07.Col·lapse */
  'collapse.basic': 'Bàsic',
  'collapse.toggle': 'Commutador',
  'collapse.accordion': 'Acordió',
  'collapse.controlled': 'Controlat',
  'collapse.uncontrolled': 'No controlat',

  /* 07.08.Desplegables */
  'dropdowns.basic': 'Bàsic',
  'dropdowns.controlled': 'Controlat',
  'dropdowns.uncontrolled': 'No controlat',
  'dropdowns.dropdown': 'Desplegable',
  'dropdowns.header': 'Capçalera',
  'dropdowns.action': 'Acció',
  'dropdowns.another-action': 'Una altra acció',
  'dropdowns.right': 'Dreta',
  'dropdowns.left': 'Esquerra',
  'dropdowns.drop-directions': 'Direccions de desplegable',
  'dropdowns.dropright': 'Desplegable a la dreta',
  'dropdowns.dropleft': 'Desplegable a l’esquerra',
  'dropdowns.small-button': 'Botó petit',
  'dropdowns.large-button': 'Botó gran',
  'dropdowns.sizing': 'Dimensionament',
  'dropdowns.split-button': 'Botó dividit',
  'dropdowns.dropup': 'Desplegable cap amunt',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill estàndard',
  'editors.quill-bubble': 'Quill bombolla',

  /* 07.10.Formularis */
  'forms.basic': 'Bàsic',
  'forms.email': 'Correu electrònic',
  'forms.email-muted': 'Mai compartirem el teu correu amb ningú.',
  'forms.password': 'Contrasenya',
  'forms.password-confirm': 'Confirmar contrasenya',
  'forms.submit': 'Envia',
  'forms.horizontal': 'Horitzontal',
  'forms.radios': 'Botons de ràdio',
  'forms.first-radio': 'Primer ràdio',
  'forms.second-radio': 'Segon ràdio',
  'forms.third-radio-disabled': 'Tercer ràdio desactivat',
  'forms.checkbox': 'Casella de selecció',
  'forms.signin': 'Iniciar sessió',
  'forms.top-labels-over-line': 'Etiquetes a sobre de la línia',
  'forms.tags': 'Etiquetes',
  'forms.date': 'Data',
  'forms.state': 'Estat',
  'forms.top-labels-in-input': 'Etiquetes a dins del camp',
  'forms.email-u': 'CORREU ELECTRÒNIC',
  'forms.password-u': 'CONTRASENYA',
  'forms.tags-u': 'ETIQUETES',
  'forms.date-u': 'DATA',
  'forms.state-u': 'ESTAT',
  'forms.grid': 'Graella de formulari',
  'forms.address': 'Adreça',
  'forms.address2': 'Adreça 2',
  'forms.city': 'Ciutat',
  'forms.city-message': 'Si us plau, selecciona una ciutat!',
  'forms.state-message': 'Si us plau, selecciona un estat!',
  'forms.zip': 'Codi postal',
  'forms.signup': 'Registra’t',
  'forms.inline': 'En línia',
  'forms.validation': 'Validació',
  'forms.default': 'Per defecte',
  'forms.firstname': 'Nom',
  'forms.firstname-message': 'Si us plau, introdueix el teu nom!',
  'forms.lastname': 'Cognom',
  'forms.lastname-message': 'Si us plau, introdueix el teu cognom!',
  'forms.name': 'Nom',
  'forms.validation-availity': 'Validació Reactstrap Availity',
  'forms.validation-formik': 'Validació Formik',

  /* 07.11.Components */
  'form-components.custom-inputs': 'Entrada personalitzada',
  'form-components.checkboxes': 'Caselles de selecció',
  'form-components.radios': 'Botons de ràdio',
  'form-components.inline': 'En línia',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'Estat únic',
  'form-components.state-multiple': 'Estats múltiples',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Selector de data',
  'form-components.date': 'Data',
  'form-components.date-range': 'Interval de dates',
  'form-components.date-with-time': 'Data amb hora',
  'form-components.embedded': 'Incrustat',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Deixa anar els arxius aquí',
  'form-components.tags': 'Etiquetes',
  'form-components.switch': 'Interruptor',
  'form-components.primary': 'Principal',
  'form-components.secondary': 'Secundari',
  'form-components.primary-inverse': 'Principal invers',
  'form-components.secondary-inverse': 'Secundari invers',
  'form-components.slider': 'Control lliscant',
  'form-components.double-slider': 'Control lliscant doble',
  'form-components.single-slider': 'Control lliscant únic',
  'form-components.rating': 'Valoració',
  'form-components.interactive': 'Interactiu',
  'form-components.readonly': 'Només lectura',
  'form-components.type-a-cake': 'Escriu un pastís',
  'form-components.start': 'Inici',
  'form-components.end': 'Fi',
  'form-components.tables': 'Taules',

  /* 07.12.Icones */
  'icons.simplelineicons': 'Icones Simple Line',
  'icons.iconsmind': 'Icones IconsMind',

  /* 07.13.Grups d’entrada */
  'input-groups.basic': 'Bàsic',
  'input-groups.sizing': 'Dimensionament',
  'input-groups.small': 'Petit',
  'input-groups.default': 'Per defecte',
  'input-groups.large': 'Gran',
  'input-groups.checkboxes-and-radios': 'Caselles i ràdios',
  'input-groups.multiple-inputs': 'Entrades múltiples',
  'input-groups.first-and-last-name': 'Nom i cognoms',
  'input-groups.multiple-addons': 'Complements múltiples',
  'input-groups.button-addons': 'Botons amb complements',
  'input-groups.button': 'Botó',
  'input-groups.buttons-with-dropdowns': 'Botons amb desplegables',
  'input-groups.dropdown': 'Desplegable',
  'input-groups.header': 'Capçalera',
  'input-groups.action': 'Acció',
  'input-groups.another-action': 'Una altra acció',
  'input-groups.custom-select': 'Selector personalitzat',
  'input-groups.options': 'Opcions',
  'input-groups.choose': 'Escull...',
  'input-groups.custom-file-input': 'Entrada de fitxer personalitzada',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hola món!',
  'jumbotron.lead':
    'Aquesta és una unitat destacada senzilla, un component de tipus jumbotron per cridar més atenció al contingut destacat.',
  'jumbotron.lead-detail':
    'Utilitza classes utilitàries per a la tipografia i els espais per distribuir el contingut dins del contenidor més gran.',
  'jumbotron.learn-more': 'Més informació',

  /* 07.15.Modal */
  'modal.basic': 'Bàsic',
  'modal.modal-title': 'Títol del modal',
  'modal.launch-demo-modal': 'Llançar modal de demostració',
  'modal.scrolling-long-content': 'Contingut llarg desplaçable',
  'modal.backdrop': 'Fons',
  'modal.backdrop-value': 'Valor del fons',
  'modal.right-modal': 'Modal dret',
  'modal.launch-right-modal': 'Llançar modal dret',
  'modal.nested-modal': 'Modal niat',
  'modal.size': 'Mida',
  'modal.launch-large-modal': 'Llançar modal gran',
  'modal.launch-small-modal': 'Llançar modal petit',

  /* 07.16.Navegació */
  'nav.basic': 'Navegació bàsica',
  'nav.active': 'Actiu',
  'nav.disabled': 'Desactivat',
  'nav.disabled-link': 'Enllaç desactivat',
  'nav.link': 'Enllaç',
  'nav.longer-link': 'Enllaç de navegació més llarg',
  'nav.another-link': 'Un altre enllaç',
  'nav.right': 'Dreta',
  'nav.dropdown': 'Desplegable',
  'nav.header': 'Capçalera',
  'nav.action': 'Acció',
  'nav.another-action': 'Una altra acció',
  'nav.horizontal-alignment': 'Alineació horitzontal',
  'nav.vertical-alignment': 'Alineació vertical',
  'nav.pills': 'Pestanyes de navegació',
  'nav.fill-justify': 'Justificar i omplir navegació',
  'nav.pills-dropdowns': 'Pestanyes amb desplegables',
  'nav.pagination-basic': 'Paginació bàsica',
  'nav.pagination-sizing': 'Mida de paginació',
  'nav.large': 'Gran',
  'nav.small': 'Petit',
  'nav.center': 'Centre',
  'nav.pagination-alignment': 'Alineació de la paginació',
  'nav.breadcrumb-basic': 'Migas de pa bàsiques',
  'nav.dark-mode': 'Mode fosc',
  'nav.log-out': 'Tancar sessió',
  'nav.maximize': 'Maximitzar',

  /* 07.17.Eines emergents */
  'popover-tooltip.popover': 'Emergents',
  'popover-tooltip.tooltip': 'Consells emergents',

  /* 07.18.Ordenable */
  'sortable.columns': 'Ordenar columnes',
  'sortable.basic': 'Bàsic',
  'sortable.handles': 'Controladors',

  /* 07.19.Mapes */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Taules */
  'table.bootstrap-tables': 'Taules Bootstrap',
  'table.bootstrap-basic': 'Taules bàsiques',
  'table.bootstrap-striped': 'Taules ratllades',
  'table.bootstrap-bordered': 'Taules amb vores',
  'table.bootstrap-borderless': 'Taules sense vores',
  'table.bootstrap-hoverable': 'Taules amb efecte hover',
  'table.bootstrap-responsive': 'Taules responsives',
  'table.react-tables': 'Taules React',
  'table.react-pagination': 'Paginació',
  'table.react-scrollable': 'Taules amb desplaçament',
  'table.react-advanced': 'Filtre, longitud i salt',
  'table.divided': 'Taula dividida',

  /* 07.21.Assistents */
  'wizard.step-name-1': 'Pas 1',
  'wizard.step-name-2': 'Pas 2',
  'wizard.step-name-3': 'Pas 3',
  'wizard.step-desc-1': 'Descripció del primer pas',
  'wizard.step-desc-2': 'Descripció del segon pas',
  'wizard.step-desc-3': 'Descripció del tercer pas',
  'wizard.content-1': 'Contingut per al primer pas.',
  'wizard.content-2': 'Contingut per al segon pas.',
  'wizard.content-3': 'Contingut de l’últim pas!',
  'wizard.content-thanks': 'Gràcies!',
  'wizard.next': 'Següent',
  'wizard.prev': 'Anterior',
  'wizard.registered': 'El teu registre s’ha completat amb èxit!',
  'wizard.async': 'Desant de manera asíncrona durant 3 segons!',

  /* 07.22.Errors */
  'error.401-not-authorized': 'Error, la sessió ha caducat.',
  'error.403-not-authorized':
    'Error, no tens permisos. Inicia sessió de nou per obtenir els permisos adequats.',
  /* Modules */
  /* aiteaview_start_trans */
  'cosbim.name': 'COSBIM 360',
  'cosbim.description':
    "L'agència immobiliària líder en oficines de qualitat a la zona euro",
  'menu.cities': 'Ciutats',
  'menu.administration-cosbim': 'Administració',
  'menu.buildings': 'Edificis',
  'menu.building': 'Construir',
  'menu.widgets': 'Widgets',
  'menu.parameters': 'Paràmetres',
  'menu.documents': 'Documents',
  'menu.cosbim': 'Cosbim',
  'menu.download': 'Descarregar dades a csv',
  'menu.metasys': 'Metasys',
  'menu.med': 'MED',
  'menu.alarms': 'Alarmes',
  'menu.settings': 'Configuració',
  'administration.accounts.alarms.criticity_title':
    'Nivells de Criticitat (Alarmes)',
  'administration.accounts.alarms.critical': 'Crític',
  'administration.accounts.alarms.warning': 'Advertència',
  'administration.accounts.alarms.minor': 'Lleu',
  'administration.accounts.alarms.informational': 'Informativa',
  'administration.groups.select-all': 'Seleccionar-ho tot',
  'administration.groups.deselect-all': 'Netejar',
  'administration.profile': 'Perfil',
  'administration.profile.edit.success': 'Usuari editat amb èxit',
  'administration.users': 'Usuaris',
  'administration.cities': 'Ciutats',
  'administration.buildings': 'Edificis',
  'administration.ocas': 'OCAs',
  'administration.ocas.name': 'Nom',
  'administration.ocas.royal_decree': 'Reial decret',
  'administration.ocas.periodicity': 'Periodicitat de la inspecció',
  'administration.ocas.create': 'Crear nova instal·lació',
  'administration.ocas.edit': 'Editar instal·lació',
  'administration.ocas.inspection_name': 'Nom de la inspecció',
  'administration.ocas.royal_decree_name': 'Nom del reial decret',
  'administration.ocas.docuware_fields': 'Camps de DocuWare',
  'administration.ocas.doc_class_field': 'Camp Classe doc',
  'administration.ocas.doc_subclass_field': 'Camp Subclasse doc',
  'administration.ocas.date.missing': 'Falta',
  'administration.ocas.filter.status': 'Estat',
  'administration.ocas.filter.status.all': 'Totes les dates',
  'administration.ocas.filter.status.danger': 'Dates en vermell',
  'administration.ocas.filter.date': "Data d'inspecció",
  'administration.ocas.installations': 'Instal·lacions ',
  'administration.ocas.current_year': 'Any actual: ',
  'administration.ocas.download_excel': 'Descarregar excel',
  'administration.ocas.building.installation': 'Instal·lació',
  'administration.ocas.building.regulation': 'Normativa',
  'administration.ocas.building.status': 'Estat',
  'administration.ocas.building.next_inspection': 'Propera inspecció',
  'administration.ocas.building.status.approved': 'Aprovada',
  'administration.ocas.building.status.conditioned': 'Condicionada',
  'administration.ocas.building.status.rejected': 'No aprovada',
  'administration.ocas.building.new_inspection_date':
    'Nova data de propera inspecció',
  'administration.ocas.building.conditioned_modal_title':
    'Canviar a estat condicional',
  'administration.ocas.building.save': 'Desar',
  'administration.widgets': 'Widgets',
  'administration.widgets.list.name': 'Nom',
  'administration.widgets.list.url': 'URL',
  'administration.widgets.list.type': 'Tipus',
  'administration.widgets.list.placement': 'Ubicació',
  'administration.widgets.list.position': 'Posició',
  'administration.widgets.edit.tittle': 'Editar widget',
  'administration.widgets.edit.name': 'Nom del widget',
  'administration.widgets.list.kind': 'Família',
  'administration.widgets.edit.kind': 'Família del widget',
  'administration.widgets.edit.type': 'Tipus de widget',
  'administration.widgets.edit.placement': 'Ubicació del widget',
  'administration.widgets.edit.position': 'Posició del widget',
  'administration.widgets.edit.url': 'URL del widget',
  'administration.widgets.edit.mobile_url': 'URL mòbil del widget',
  'administration.widgets.edit.image': 'Imatge del widget',
  'administration.widgets.edit.groups': 'Grups',
  'administration.widgets.edit.validation.error.title': 'Error de validació',
  'administration.widgets.edit.validation.error.message':
    'Si us plau, completeu tots els camps obligatoris: nom, tipus, ubicació, posició i URL',
  'administration.widgets.placement': 'Ubicació',
  'administration.widgets.image': 'Seleccioneu una imatge',
  'administration.widgets.portal': 'Portal',
  'administration.widgets.cosbim': 'Cosbim',
  'administration.widgets.planos': 'Plans',
  'administration.widgets.reports': 'Informes',
  'administration.widgets.heatmap': 'Mapa de calor',
  'administration.widgets.intranet': 'Intranet',
  'administration.widgets.climate': 'Clima',
  'administration.widgets.lightning': 'Il·luminació',
  'administration.widgets.assistant': 'Assistència',
  'administration.widgets.electricidad': 'Electricitat',
  'administration.widgets.agua': 'Aigua',
  'administration.widgets.gas': 'Gas',
  'administration.widgets.districlima': 'Districlima',
  'administration.widgets.co2': 'CO2',
  'administration.widgets.co2-ext': 'CO2 Ext.',
  'administration.widgets.cala': "Qualitat de l'aire",
  'administration.widgets.temperatura': 'Temperatura',
  'administration.widgets.humedad': 'Humitat',
  'administration.widgets.afluencia': 'Afluència',
  'administration.widgets.contacts': 'Contactes',
  'administration.settings': 'Configuració',
  'administration.settings.portfolio-coords': 'Coordenades',
  'administration.settings.latitude': 'Latitud',
  'administration.settings.longitude': 'Longitud',
  'administration.settings.market-value': 'Valor de mercat (€m)',
  'administration.settings.total-area': 'Superfície total (m²)',
  'administration.settings.total-buildings': "Nombre d'edificis",
  'administration.settings.portfolio-kpis': 'KPI del portfoli',
  'administration.settings.email': 'Email de registre',
  'administration.settings.csv': 'CSV Edificis',
  'administration.settings.upload.csv.datamaster': 'Carregar CSV Dades Mestres',
  'administration.settings.upload.csv.spacesclients':
    'Carregar CSV Espais Clients',
  'administration.settings.uploading': 'Pujant CSV...',
  'administration.settings.upload': 'Carregar',
  'administration.settings.disclaimer.title': 'Disclaimers',
  'administration.settings.privacy.title': 'Política de privacitat',
  'administration.settings.legal.hint': 'Si es deixa buit no es mostra.',
  'administration.settings.legal.spanish': 'Text en castellà',
  'administration.settings.legal.english': 'Text en anglès',
  'administration.settings.legal.cat': 'Text en català',
  'administration.settings.legal.french': 'Text en francès',
  'administration.settings.contact.title': 'Contacte',
  'administration.settings.contact.hint':
    'Si es deixa buit no hi ha pàgina de contacte. El formulari només apareix amb correu.',
  'administration.settings.contact.address': 'Adreça',
  'administration.settings.contact.phone': 'Telèfon',
  'administration.settings.contact.hours': 'Horari',
  'administration.settings.contact.email': 'Correu de contacte',
  'administration.settings.save': 'Desar configuració',
  'administration.settings.scraper_config': 'Scraper KPI',
  'administration.settings.execution.title': "Tipus d'execució",
  'administration.settings.execution.daily': 'Diari',
  'administration.settings.execution.weekly': 'Setmanal',
  'administration.settings.execution.monthly': 'Mensual',
  'administration.settings.day.week': 'Dia de la setmana',
  'administration.settings.day.month': 'Dia del mes',
  'administration.settings.select.day': 'Seleccioneu un dia',
  'administration.settings.notification.scraper_updated':
    'Configuració actualitzada correctament',
  'administration.settings.notification.updated': 'Configuració actualitzada',
  'administration.settings.day.monday': 'Dilluns',
  'administration.settings.day.tuesday': 'Dimarts',
  'administration.settings.day.wednesday': 'Dimecres',
  'administration.settings.day.thursday': 'Dijous',
  'administration.settings.day.friday': 'Divendres',
  'administration.settings.day.saturday': 'Dissabte',
  'administration.settings.day.sunday': 'Diumenge',
  'administration.scraper.save': 'Desar configuració Scraper',
  'administration.settings.hide_scraper_config':
    'Amagar la configuració del Scraper KPI',
  'administration.settings.show_scraper_config':
    'Mostrar la configuració del Scraper KPI',
  'administration.parameters': 'Paràmetres',
  'administration.documents': 'Documents',
  'administration.documents.assignment': 'Assignació de documents',
  'administration.documents.assign': 'Assignar',
  'administration.assign.users': 'Usuaris assignats',
  'administration.assign.cities': 'Ciutats assignades',
  'administration.assign.buildings': 'Edificis assignats',
  'administration.documents.hide': 'Amagar',
  'administration.assign.widgets': 'Widgets assignats',
  'administration.assign.parameters': 'Paràmetres assignats',
  'administration.assign.documents': 'Documents assignats',
  'administration.assign.clients': 'Clients assignats',
  'administration.permission.user': 'Permís',
  'administration.accounts.surname': 'Cognom',
  'administration.accounts.tittle.edit': 'Editar usuari',
  'administration.accounts.tittle.delete': 'Eliminar aquest usuari?',
  'administration.accounts.delete.success': 'Usuari eliminat correctament',
  'administration.accounts.type': 'Tipus',
  'administration.accounts.auth.internal': 'Intern',
  'administration.accounts.auth.external': 'Externa',
  'administration.accounts.validated.password':
    'La contrasenya ha de contenir almenys 8 caràcters, una majúscula, un número i un caràcter especial',
  'administration.accounts.selector.language': 'Idioma',
  'administration.accounts.selector.homescreen.placeholder':
    "Seleccioneu una pàgina d'inici...",
  'administration.accounts.selector.homescreen.portfolio': 'Portfoli',
  'administration.accounts.selector.homescreen.space': 'Ciutat',
  'administration.accounts.selector.homescreen.building': 'Edifici',
  'administration.accounts.selector.homescreen.client': 'Client',
  'administration.accounts.selector.authtype': "Tipus d'autenticació",
  'administration.accounts.selector.authtype.placeholder':
    "Seleccioneu el tipus d'autenticació...",
  'administration.accounts.selector.language.placeholder':
    'Seleccioneu un idioma...',
  'administration.accounts.selector.widgets.placeholder':
    'Seleccioneu un widget...',
  'administration.accounts.myprofile.current_password': 'Contrasenya actual',
  'administration.homescreen.portofolio': 'Portfoli',
  'administration.homescreen.space': 'Ciutat',
  'administration.homescreen.building': 'Edifici',
  'administration.homescreen.client': 'Client',
  'administration.cities.tittle.create': 'Crear nova ciutat',
  'administration.cities.tittle.edit': 'Editar ciutat',
  'administration.city.tittle.delete': 'Eliminar aquesta ciutat?',
  'administration.buildings.tittle.create': 'Crear nou edifici',
  'administration.buildings.tittle.edit': 'Editar edifici',
  'administration.buildings.tittle.warning': 'Avís',
  'administration.buildings.tittle.delete': 'Eliminar aquest edifici?',
  'administration.buildings.tittle.accept': 'Acceptar',
  'administration.buildings.image.delete': 'Eliminar imatge',
  'administration.buildings.image.delete.body':
    'Vols eliminar la imatge associada al client ',
  'administration.buildings.image.delete.success':
    'Imatge eliminada correctament',
  'notification.success.title': 'Èxit',
  'administration.buildings.create.success': 'Edifici creat correctament',
  'administration.buildings.edit.success': 'Edifici editat correctament',
  'administration.buildings.longlat.validation':
    'El valor ha de ser un número decimal amb un màxim de 3 dígits enters i 7 decimals.',
  'administration.buildings.required_fields':
    'Emplena els camps obligatoris següents:',
  'administration.buildings.fix_errors':
    'Corregeix els errors indicats abans de desar.',
  'administration.buildings.invalid_link':
    "L'enllaç ha de ser una URL vàlida, ha de començar per http o https.",
  'administration.buildings.tittle.cancel': 'Cancel·lar',
  'administration.buildings.link.grafana':
    "Enllaç al quadre de comandament d'ocupació",
  'administration.buildings.occupation': "Dades d'ocupació",
  'administration.tittle.back': 'Tornar enrere',
  'administration.building.certification': 'Certificació',
  'administration.widgets.tittle.create': 'Crear nou widget',
  'administration.parameters.tittle.create': 'Crear nou paràmetre',
  'administration.widgets.tittle.edit': 'Editar widget',
  'administration.parameters.tittle.edit': 'Editar paràmetre',
  'administration.widgets.tittle.delete': 'Eliminar aquest widget?',
  'administration.widgetConf.tittle.delete':
    'Eliminar aquest widget de configuració?',
  'administration.widgetConf.delete.success':
    'Widget de configuració eliminat amb èxit',
  'administration.parameters.tittle.delete': 'Eliminar aquest paràmetre?',
  'administration.documents.tittle.edit': 'Editar enllaç',
  'administration.document.edit.success': 'Enllaç editat amb èxit',
  'administration.widgets.position': 'Posició a la pantalla principal',
  'administration.widgets.front_carusel': 'Carrusel frontal',
  'administration.structure': 'Estructura',
  'administration.widgets.url': 'URL',
  position: 'Posició',
  'administration.assets': 'Tipus',
  'administration.img': "Imatge de l'edifici",
  'administration.img.city': 'Imatge de la ciutat',
  'administration.img.widget': 'Imatge del widget',
  img: 'Imatge',
  'administration.accounts.superuser': 'Super usuari',
  'administration.accounts.user': 'Client',
  'administration.accounts.user.can.see.administration':
    "L'usuari pot veure l'administració",
  'administration.userRoles': "Rols d'usuari",
  'administration.selectUserRole': "Seleccionar rol d'usuari",
  'administration.selectUserRoleAssistant':
    'Has de seleccionar un rol per al widget Assistant',
  'filter.city': 'Filtrar per ciutat',
  'filter.assets': 'Filtrar per actius',
  'filter.projects': 'Filtrar per projectes',
  'filter.buildings': 'Filtrar per edifici',
  'filter.widgets': 'Filtrar per widgets',
  'select.assets': 'Actiu',
  'select.projects': 'Projecte',
  'module.name': 'Nom del mòdul',
  'parameters.name': 'Nom del paràmetre',
  'parameters.name.required': 'El nom de la carpeta és obligatori.',
  'parameters.url': 'Enllaç del document',
  'document.send': 'Enviar documents',
  'document.receiver': 'Destinatari',
  'document.subject': 'Assumpte',
  'document.comment': 'Comentari',
  'document.attached': 'Adjuntar fitxers',
  'document.sending': 'Enviant correu, si us plau, espera...',
  'document.sent': 'Correu enviat amb èxit',
  'select.building': 'Seleccionar edifici',
  'url.sin.dato': "# si és un contenidor d'un altre nivell",
  'forms.message': 'Missatge',
  'alert.documents': 'Has de seleccionar un edifici per veure la documentació.',
  'dashboard.title': 'Monitoratge energètic',
  'forms.range': 'Interval de dates',
  'forms.year-range': "Interval d'anys",
  'menu.consumption': 'Consum',
  'air.quality': "Qualitat de l'aire",
  'air.quality.daily': "Qualitat de l'aire (diari)",
  'air.quality.monthly': "Qualitat de l'aire (mensual)",
  'air.quality.yearly': "Qualitat de l'aire (anual)",
  'air.quality.ext': 'Qualitat Aire Ext.',
  'air.quality.history': "Històric de Qualitat de l'aire",
  'air.co2': 'CO2',
  'air.co2.daily': 'CO2 (diari)',
  'air.co2.monthly': 'CO2 (mensual)',
  'air.co2.yearly': 'CO2 (anual)',
  'air.co2.ext': 'CO2 Ext.',
  'air.co2.history': 'Històric de CO2',
  'air.co2.ext.history': 'Històric de CO2 Ext.',
  'carbon.footprint': 'Petjada Carboni',
  'carbon.footprint.history': 'Històric Petjada de Carboni',
  'metric.temperature-forecast': 'Previsió Temperatura',
  'metric.occupation-evolution': 'Evol. ocupació',
  'metric.occupation-percentage': 'Percentatge Afluència',
  'metric.occupation-maximum-daily': 'Màx. Ocupació diària',
  'metric.bathroom-transit': 'Trànsit lavabos',
  'metric.alarms': 'Alarmes',
  'building.flows': 'Fluxos',
  'flows.view.real': 'Vista real',
  'flows.view.max': 'Vista de màxims',
  'flows.growth.previous_year': '(Any ant.)',
  'flows.growth.range_title': "Creixement d'Afluència total",
  'chart.occupation': 'Ocupació',
  'occupation.implantation': 'En implantació',
  'occupation.max_since_january': "Valor màxim des de l'1 de gener",
  'meteorology.variables.internal': 'Intern',
  'meteorology.variables.external': 'Extern',
  'meteorology.year.to.date': 'Any fins avui',
  'menu.floors': 'Plantes',
  'menu.customers': 'Clients',
  'menu.office': 'Oficines',
  'gas.consumption': 'Cons. de gas',
  'gas.consumption.history': 'Històric de consum de gas',
  'gas.consumption.daily': 'Cons. Gas (diari)',
  'gas.consumption.monthly': 'Cons. Gas (mensual)',
  'gas.consumption.yearly': 'Cons. Gas (anual)',
  'electrical.consumption': 'Cons. elèctric',
  'electrical.consumption.history': 'Històric de consum elèctric',
  'electrical.consumption.daily': 'Cons. Elèct. (diari)',
  'electrical.consumption.monthly': 'Cons. Elèct. (mensual)',
  'electrical.consumption.yearly': 'Cons. Elèct. (anual)',
  'electrical.consumption.symmetrical': 'Cons. elèctric simétric',
  'electrical.consumption.symmetrical.history':
    'Històric de consum elèctric simétric',
  'electrical.consumption.symmetrical.daily': 'Cons. Elèct. Sim. (diari)',
  'electrical.consumption.symmetrical.monthly': 'Cons. Elèct. Sim. (mensual)',
  'electrical.consumption.symmetrical.yearly': 'Cons. Elèct. Sim. (anual)',
  'water.consumption': 'Cons. d’aigua',
  'water.consumption.history': 'Històric de consum d’aigua',
  'water.consumption.daily': 'Cons. Aigua (diari)',
  'water.consumption.monthly': 'Cons. Aigua (mensual)',
  'water.consumption.yearly': 'Cons. Aigua (anual)',
  'districlima.consumption': 'DistriClima',
  'districlima.consumption.history': 'Històric DistriClima',
  'districlima.consumption.daily': 'DistriClima (total) (diari)',
  'districlima.consumption.monthly': 'DistriClima (total) (mensual)',
  'districlima.consumption.yearly': 'DistriClima (total) (anual)',
  'districlima.consumption.cold': 'DistriClima (fred)',
  'districlima.consumption.cold.daily': 'DistriClima (fred) (diari)',
  'districlima.consumption.cold.monthly': 'DistriClima (fred) (mensual)',
  'districlima.consumption.cold.yearly': 'DistriClima (fred) (anual)',
  'districlima.consumption.hot': 'DistriClima (calor)',
  'districlima.consumption.hot.daily': 'DistriClima (calor) (diari)',
  'districlima.consumption.hot.monthly': 'DistriClima (calor) (mensual)',
  'districlima.consumption.hot.yearly': 'DistriClima (calor) (anual)',
  'districlima.total': 'Total',
  'districlima.hot': 'Calor',
  'districlima.cold': 'Fred',
  'chart.temperature': 'Temperatura',
  'chart.temperature.history': 'Històric de temperatura',
  'chart.temperature.daily': 'Temperatura (diari)',
  'chart.temperature.monthly': 'Temperatura (mensual)',
  'chart.temperature.yearly': 'Temperatura (anual)',
  'chart.humidity': 'Humitat',
  'chart.humidity.ext': 'Humitat Ext.',
  'chart.humidity.history': 'Històric d’humitat',
  'chart.humidity.daily': 'Humitat (diari)',
  'chart.humidity.monthly': 'Humitat (mensual)',
  'chart.humidity.yearly': 'Humitat (anual)',
  'meteorology.temperature': 'Temperatura',
  'meteorology.humidity': 'Humitat',
  'dashboard.sub.buildings': 'Subedificis',
  'building.characteristics': 'Característiques generals',
  'city.madrid': 'Madrid',
  'city.barcelona': 'Barcelona',
  'city.paris': 'Paris',
  'floor.without.client': 'Sense client',
  'building.floor.ground': 'Planta baixa',
  'building.floor.1': 'Planta 1',
  'building.floor.2': 'Planta 2',
  'building.floor.3': 'Planta 3',
  'building.floor.4': 'Planta 4',
  'building.floor.5': 'Planta 5',
  'building.floor.6': 'Planta 6',
  'building.floor.7': 'Planta 7',
  'building.blueprints': 'Plànols',
  'building.reports': 'Informes',
  'building.directory': 'Directori',
  'building.portfolio': 'Portafolis',
  'building.portfolio.group': 'Portfolio',
  'home.no-buildings': 'Encara no tens edificis assignats.',
  'home.no-portfolio': 'Encara no hi ha cap portafoli.',
  'aiteaview.login-sso': 'Inicia sessió amb SSO',
  'administration.search': 'Cercar...',
  'user.forgot-password.enter.email.error':
    'Si us plau, introdueix la teva adreça de correu electrònic',
  'user.forgot-password.invalid.email.error':
    'Adreça de correu electrònic no vàlida',
  'user.forgot-reset-password.forgot.password.error':
    'Error de recuperació de contrasenya',
  'user.forgot-password.forgot.password.success.body':
    'Si ets usuari de la plataforma rebràs un correu electrònic amb un enllaç per restablir la contrasenya',
  'user.forgot-password.forgot.password.success.title':
    'Has oblidat la contrasenya',
  'user.forgot-reset-password.body.title': 'LA MÀGIA ESTÀ EN ELS DETALLS',
  'user.forgot-reset-password.body.body.one':
    'Si ets usuari de la plataforma rebràs un correu electrònic amb un enllaç per restablir la contrasenya.',
  'user.forgot-reset-password.body.body.two':
    'Si us plau, utilitza el teu correu electrònic per restablir la contrasenya.',
  'user.forgot-reset-password.body.body.three': 'Si no ets membre, si us plau',
  'user.forgot-reset-password.body.body.register': "registra't",
  'edi.nodata.available': 'No hi ha mesura',
  'edi.connection.error': 'Error de connexió, torna-ho a provar',
  'edi.connection.timeout': "S'ha esgotat el temps d'espera, torna-ho a provar",
  'edi.portfolio.market.value': 'Valor de mercat',
  'edi.portfolio.total.surface.area': 'Superfície total',
  'edi.portfolio.assets.number': "Nombre d'actius",
  'edi.portfolio.assets.number.unit': 'actius',
  'edi.nodata.to.download': 'No hi ha dades per descarregar',
  'edi.download.minimum.period':
    'No es poden descarregar dades per a períodes inferiors a un mes',
  'city.madrid.directory': 'Directori Madrid',
  'city.barcelona.directory': 'Directori Barcelona',
  'building.floor': 'Planta',
  'building.floor.download.blueprint': 'Descarregar',
  'building.floor.file': 'Fitxer',
  'building.client': 'Client',
  'building.no_floors': 'No hi ha pisos disponibles.',
  'building.level': 'Nivell',
  'building.no_icon': 'Sense icona',
  'card.consumption.total': 'Total',
  'card.consumption.heating': 'Calefacció',
  'card.consumption.cooling': 'Refrigeració',
  'building.heatmap': 'Mapa de calor',
  'disclaimer.title': 'Avís Important',
  'disclaimer.button.accept': 'Acceptar',
  'disclaimer.error.get': "Error en comprovar l'estat de l'avís legal",
  'disclaimer.error.accept': "Error en desar l'acceptació de l'avís legal",
  'client.apps.reports': 'Informes',
  'client.apps.heatmap': 'Mapes de calor',
  'client.apps.intranet': 'Intranet',
  'client.apps.climate': 'Clima',
  'client.apps.lightning': 'Il·luminació',
  'administration.buildings.without.img': 'Sense imatge',
  'building.blueprint.implantation': 'Implantació',
  'building.blueprint.architecture': 'Arquitectura',
  'building.blueprint.coordination.imp': 'Coordinació Impl.',
  'building.blueprint.coordination.arch': 'Coordinació Arq.',
  'building.apps': 'Apps',
  'contact.with.us': 'Contacta amb nosaltres',
  'building.blueprint.coordination': 'Coordinació',
  'administration.settings.autodesk.title': 'Autodesk',
  'administration.settings.set.period.time':
    "Establir període de descàrrega d'Autodesk (hores)",
  'administration.settings.set.period.time.visualization':
    "Establir període de visualització d'Autodesk (dies)",
  'administration.accounts.autodesk_id': 'ID Autodesk',
  'administration.settings.footprint_objective':
    'Objectiu de petjada de carboni',
  'administration.settings.report_config': "Configuració avançada de l'informe",
  'administration.settings.manage_reports': 'Gestionar informes',
  'settings.report.lang.es': 'Espanyol',
  'settings.report.lang.fr': 'Francès',
  'settings.report.lang.cat': 'Català',
  'settings.report.lang.en': 'Anglès',
  'edi.dashboard.widgets.edit-chart': 'Editar gràfic',
  'date.sunday': 'Diumenge',
  'date.monday': 'Dilluns',
  'date.tuesday': 'Dimarts',
  'date.wednesday': 'Dimecres',
  'date.thursday': 'Dijous',
  'date.friday': 'Divendres',
  'date.saturday': 'Dissabte',
  'date.january': 'Gener',
  'date.february': 'Febrer',
  'date.march': 'Març',
  'date.april': 'Abril',
  'date.may': 'Maig',
  'date.june': 'Juny',
  'date.july': 'Juliol',
  'date.august': 'Agost',
  'date.september': 'Setembre',
  'date.october': 'Octubre',
  'date.november': 'Novembre',
  'date.december': 'Desembre',
  'dashboard.hide_reports_config': 'Amagar la configuració dels informes',
  'dashboard.show_reports_config': 'Mostrar la configuració dels informes',
  'administration.widgets.flows': 'Fluxos',
  'administration.widgets.deepki': 'Deepki',
  'administration.widgets.med': 'MED',
  'administration.widgets.metasys_barcelona': 'Metasys Barcelona',
  'administration.widgets.metasys_madrid': 'Metasys Madrid',
  'administration.widgets.aitea_building': 'Edifici Aitea',
  'administration.reports.title-1': 'Títol 1',
  'administration.reports.title-2': 'Títol 1.1',
  'administration.reports.title-3': 'Títol 1.1.1',
  'administration.reports.title-4': 'Títol 1.1.1.1',
  'administration.reports.title-5': 'Títol 1.1.1.1.1',
  'administration.reports.title-6': 'Títol 1.1.1.1.1.1',
  'administration.reports.text-body': 'Cos del text',
  'administration.reports.table-chart-title': 'Títol de taules i gràfics',
  'building.basement': 'Soterrani',
  'building.semi_basement': 'Semisoterrani',
  'building.garage': 'Garatge',
  'building.attic': 'Àtic',
  'building.mezzanine': 'Entreplanta',
  'chart.unconsolidated-data': 'Mes en curs',
  'chart.previous-year': 'Any anterior',
  'chart.no-data': 'No hi ha dades per mostrar',
  'chart.loading': 'Carregant...',
  'chart.target': 'Objectiu 2030',
  'chart.maximum': 'Màxim',
  'chart.minimum': 'Mínim',
  'chart.co2-rite': 'Valor màxim de referència de CO2',
  'edi.widgets.chart-edi': 'Gràfic AiteaView',
  'administration.building.no_certificates': 'No hi ha certificats assignats',
  'administration.permission.admin': 'Administrador',
  'administration.widgets.placement.carousel': 'Carrusel',
  'administration.widgets.placement.information': 'Informació',
  'administration.widgets.placement.directory': 'Directori',
  'administration.widgets.placement.data': 'Dades',
  'administration.group.all': 'Tots',
  'administration.group.building': 'Edifici',
  'administration.group.subbuilding': 'Sub edifici',
  'administration.group.client': 'Client',
  'chart.humidity-rite': 'Màxim Reial decret 486/1997',
  'chart.humidity-min-rite': 'Mínim Reial decret 486/1997',
  'cosbim.parameters.not-configured':
    'Aquest edifici encara no té carpetes configurades.',
  'cosbim.documents.not.found': 'No hi ha documents en aquest mòdul',
  'cosbim.open.all.nodes': 'Obrir totes les carpetes',
  'cosbim.close.all.nodes': 'Tancar totes les carpetes',
  'cosbim.pdf': 'PDF',
  'cosbim.cad': 'CAD',
  'cosbim.docuware.no-ue-code':
    'Aquest edifici no té codi d’unitat econòmica, que és el que l’identifica a DocuWare. Sense ell no es poden mostrar els seus documents.',
  'cosbim.building.not-found':
    'No s’ha trobat l’edifici. Comprova l’enllaç: aquesta pantalla només mostra edificis.',
  'cosbim.docuware.forbidden':
    'No tens permís per veure els documents d’aquest edifici.',
  'cosbim.docuware.unreachable':
    'No hi ha connexió amb DocuWare. Les carpetes es mostren buides fins que torni el servei.',
  'cosbim.docuware.error':
    'DocuWare ha retornat un error. Les carpetes es mostren buides, però pot ser que sí que tinguin documents.',
  'cosbim.docuware.downloading': 'Descarregant...',
  'cosbim.docuware.view': 'Veure el document',
  'cosbim.docuware.download': 'Descarregar el document',
  'cosbim.docuware.not_viewable':
    'Aquest document no es pot veure al navegador; es descarrega amb la icona.',
  'cosbim.docuware.viewer.close': 'Tanca',
  'cosbim.docuware.viewer.unsupported':
    'Aquest document no es pot mostrar aquí; descarrega’l per obrir-lo.',
  'cosbim.docuware.download_failed': 'No s’ha pogut descarregar el document',
  'cosbim.docuware.view_failed': 'No s’ha pogut obrir el document',
  'cosbim.docuware.retry': 'Tornar-ho a provar',
  'cosbim.docuware.truncated':
    'Hi ha més documents dels que DocuWare retorna de cop, així que en pot faltar algun a la llista.',
  'cosbim.docuware.folder.loading': 'Carregant documents...',
  'cosbim.docuware.folder.unavailable': 'No disponible',
  'cosbim.bim.load_failed': 'No s’han pogut carregar els documents de BIM360.',
  'cosbim.bim.cache_unavailable': "Memòria cau d'Autodesk no disponible.",
  'cosbim.bim.download_failed': 'No s’ha pogut descarregar l’arxiu de BIM360.',
  'cosbim.node.without_name': 'Sense nom',
  'parameters.hidden.success': 'Carpeta amagada',
  'parameters.visible.success': 'Carpeta visible',
  'documents.empty.links':
    'Aquest edifici no té cap carpeta de tipus Link, que són les úniques que es configuren aquí.',
  'documents.empty.no_cosbim':
    'Aquest edifici no té cap mòdul COSBIM associat.',
  'building.autodesk-id-missing': "L'edifici no té ID d'Autodesk configurat.",
  'alarms.no.registred': 'No hi ha alarmes registrades',
  'alarms.non.critical': 'No crítica',
  'alarms.critical': 'Crítica',
  'alarms.without.message': 'Sense missatge',
  'assistant.ask': "Pregunta'm el que vulguis...",
  'building.contacts': 'Contactes',
  'building.information': 'Informació de l’edifici',
  'building.services': 'Serveis',
  'building.validations': 'Validacions',
  'building.contacts.last.update': 'Última actualització',
  'building.create.service': 'Crear un nou servei',
  'building.create.validation': 'Crear una nova validació',
  'building.edit.service': 'Editar el servei',
  'building.edit.validation': 'Editar la validació',
  'building.service.name': 'Nom',
  'building.service.description': 'Descripció',
  'building.validation.service': 'Servei',
  'building.validation.field': 'Camp',
  'building.validation.type': 'Tipus',
  'building.form.cups': '+ Afegir CUPS',
  'building.form.ue_code': '+ Afegir codi UE',
  'building.subbuildings.ue_codes': 'Codis UE de subedificis',
  'building.generate.reports': 'Generar informe',
  'building.report.consumption.only.building.or.client.message':
    "L'informe de consum només es pot generar des d'un edifici o un client",
  'consumption.report.send': 'Enviar',
  'date.range.invalid': 'Rang de dates no vàlid',
  'consumption.report.missing_data': "Falten dades de l'edifici o del client",
  'consumption.report.success': 'Informe generat correctament',
  'consumption.report.generating': 'Generant informe...',
  'consumption.report.no_cups':
    'Aquest informe no es pot generar en aquest edifici perquè és un edifici de baixa tensió.',
  'consumption.report.email_sent':
    'Informe enviat correctament per correu electrònic.',
  'building.ue_code': 'Codi UE',
  'building.tipology': 'Tipologia',
  'building.status': 'Estat',
  'building.parent_space': 'Ciutat',
  'building.basic_data': 'Dades bàsiques',
  'building.tipology.monousuario': 'Monousuari',
  'building.tipology.multiusuario': 'Multiusuari',
  'building.tipology.en_construction': 'En construcció',
  'building.status.requerimiento': 'Requeriment',
  'building.status.explotacion': 'Explotació',
  'building.status.fin_de_obra': 'Fi d’obra',
  'building.contact.tecnico': 'Tècnic Associat',
  'building.contact.csm': 'CSM Associat',
  'building.contact.fm': 'Facility Manager',
  'building.contact.name': 'Nom',
  'building.contact.email': 'Correu',
  'building.contact.phone': 'Telèfon',
  'building.contact.company': 'Companyia',
  'building.contact.24h.ssgg': 'Contacte 24h Serveis Generals',
  'building.contact.24h.pci': 'Contacte PCI 24h',
  'building.contact.24h.vertical_transport': 'Telèfon 24h transport vertical',
  'building.contact.24h.medium_voltage': 'Contacte 24h mitja tensió',
  'building.contact.24h.security_phone': 'Telèfon seguretat 24h',
  'building.contact.24h.vigilance': 'Vigilància 24h',
  'building.contact.24h': '24 hores',
  'building.phone.hours': 'Telèfon 24 hores',
  'building.phone.hours.other': 'Telèfon 24 hores (altre)',
  'building.contact.technician': 'Tècnic',
  'building.contact.coordinator': 'Coordinador',
  'building.phone.other': 'Altre telèfon',
  'building.shift': 'Torn',
  'building.notes': 'Observacions',
  'administration.services.tittle.delete': 'Voleu eliminar aquest servei?',
  'administration.contacts.tittle.delete':
    'Esteu segur de voler esborrar aquest contacte?',
  'administration.settings.verification.title': 'Validacions contactes',
  'administration.settings.verification.enabled':
    'Activar sistema de verificació',
  'administration.settings.verification.max.days': 'Dies màxims de confirmació',
  'administration.settings.verification.periodicity.days':
    'Periodicitat de validacions (dies)',
  'building.contacts.add.technician': 'Afegir contacte',
  'building.contacts.delete.contact': 'Esborrar contacte',
  'technician.created.success': 'Contacte creat correctament',
  'service.updated.success': 'Editat correctament',
  'service.deleted.success': 'Eliminat correctament',
  'service.created.success': 'Creat correctament',
  'administration.validations.tittle.delete':
    'Estàs segur que vols eliminar aquesta validació?',
  'email.verification.success': 'Correu verificat correctament',
  'email.verification.error': "No s'ha pogut verificar el correu",
  'email.verification.go_to_login': 'Anar al login',
  'administration.contacts.permissions.title': 'Permisos de contactes',
  'administration.contacts.permissions.read': 'Lectura',
  'administration.contacts.permissions.write': 'Escriptura',
  'administration.contacts.permissions.validate': 'Validació',
  'building.validate.data': 'Validar dades',
  'administration.settings.validation.period.days':
    'Periodicitat de validació de dades (dies)',
  'assistant.loading': 'Carregant assistent...',
  'assistant.location.portfolio': 'Estàs consultant el portfolio de [name].',
  'assistant.location.city': 'Estàs consultant els edificis de [name].',
  'assistant.location.building': 'Estàs consultant [name].',
  'building.data_validated': 'Validat',
  'building.last_validated_at': 'Data de darrera validació',
  'building.last_validated_by': 'Validat per',
  'carbon.footprint.message':
    'Emissions operacionals dels Scopes 1 + 2 + 3 segons el Greenhouse Gas Protocol (GHG Protocol) en la seva metodologia oficial de càlcul market-based.',
  'building.contact.role': 'Rol',
  'contacts.download.title': 'Generar Excel de Contactes',
  'contacts.download.select.buildings': 'Selecciona edificis a incloure:',
  'contacts.download.select.all': 'Seleccionar tot',
  'contacts.download.download': 'Descarregar',
  'contacts.download.send': 'Enviar',
  'contacts.download.no.buildings': 'Selecciona almenys un edifici',
  'contacts.download.success': 'Excel de contactes descarregat correctament',
  'contacts.download.email.sent':
    'Llistat de contactes enviat correctament per correu',
  'parameters.name.duplicated':
    'Ja existeix una carpeta amb aquest nom al mateix nivell.',
  'parameters.name.too_long':
    'La ruta completa supera els 200 caracters. Escurca el nom.',
  'parameters.path.preview': 'Ruta completa',
  'parameters.node_type': 'Tipus de parametre',
  'parameters.node_type.container': 'Contenidor',
  'parameters.node_type.docuware': 'Contenidor DocuWare',
  'parameters.node_type.autodesk': 'Contenidor AutoDesk',
  'parameters.node_type.link': 'Link',
  'parameters.node_type.link_hint':
    'Un Contenidor nomes agrupa: per mostrar documents, tria Contenidor DocuWare. Un Link no admet subcarpetes.',
  'parameters.node_type.link_has_children':
    'No es pot convertir en Link: la carpeta te subcarpetes.',
  'parameters.node_type.drop_filter':
    'En canviar el tipus seliminara el filtre de DocuWare.',
  'parameters.docuware.cabinet': 'Arxivador',
  'parameters.docuware.cabinet_required': 'Tria un arxivador.',
  'parameters.docuware.cabinet_unavailable':
    'No sha pogut carregar la llista darxivadors.',
  'parameters.docuware.clase_doc': 'Classe doc',
  'parameters.docuware.subclase_doc': 'Subclasse doc',
  'parameters.docuware.tipo_doc': 'Tipus doc',
  'parameters.filter.add': 'Afegir',
  'parameters.filter.placeholder': 'Escriu un valor i prem Intro',
  'parameters.filter.any_of':
    'Amb diversos valors en un mateix camp es mostren els documents de qualsevol d’ells. Els camps entre si s’han de complir tots.',
  'parameters.docuware.values_empty':
    'Aquests valors no apareixen avui en cap document, pot ser una errada o que encara no hi hagi res carregat amb aquest valor: {values}',
  'parameters.docuware.filter_empty':
    'Un filtre sense cap valor mostraria tots els documents de ledifici.',
  'parameters.docuware.checking': 'Comprovant a DocuWare...',
  'parameters.docuware.ok': 'El filtre retorna {count} documents.',
  'parameters.docuware.no_match':
    'Larxivador te {count} documents de lambit, pero cap compleix aquest filtre.',
  'parameters.docuware.field_empty':
    'Aquest camp es el que deixa el filtre buit.',
  'parameters.docuware.empty_scope':
    'Encara no hi ha documents en aquest ambit, aixi que no es pot comprovar el filtre.',
  'parameters.docuware.unreachable': 'No hi ha connexio amb DocuWare.',
  'parameters.docuware.gateway_error': 'DocuWare ha retornat un error.',
  'parameters.docuware.no_ue_code': 'Ledifici no te codi dunitat economica.',
  'parameters.docuware.saves_anyway': 'La carpeta es desa igualment.',
  'parameters.docuware.save_anyway': 'Desa igualment',
  'parameters.docuware.save_unchecked': 'Desar sense comprovar',
  'parameters.reorder.up': 'Pujar',
  'parameters.reorder.down': 'Baixar',
  'parameters.empty': 'Encara no hi ha carpetes.',
  'parameters.empty.search': 'Cap parametre coincideix amb la cerca.',
  'parameters.created.success': 'Carpeta creada correctament',
  'parameters.updated.success': 'Carpeta actualitzada correctament',
  'parameters.deleted.success': 'Carpeta eliminada correctament',
  'administration.widgets.plans': 'Planols',
  'administration.accounts.tittle.edit.user': 'Editar usuari',
  'client.reports.floors.title': 'Seleccioneu les plantes',
  'client.reports.floors.empty':
    'No hi ha plantes disponibles per a aquest client.',
  'client.reports.floors.required': 'Seleccioneu almenys una planta',
  'client.reports.dashboard.required': 'Seleccioneu un informe',
  'client.reports.confirm': 'Confirmar',
  'client.reports.cancel': 'Cancel·lar',
  'client.reports.generate.pdf': 'Generar PDF',
  'client.reports.send.email': 'Enviar per correu',
  'client.reports.selected.floors': 'Plantes seleccionades',
  'date.range.same.year': 'Només es poden triar mesos del mateix any',
  'client.reports.generating': 'Generant informe...',
  'client.reports.pdf.success': 'Informe generat correctament',
  'client.reports.email.success': 'Informe enviat al teu correu',
  'client.reports.email.sending': "Enviant l'informe...",
  'client.reports.pdf.error': 'No s’ha pogut generar l’informe',
  'client.reports.floors.resolving': 'Preparant les plantes...',
  'client.reports.floors.error':
    "No s'han pogut resoldre les plantes de l'informe",
  'client.reports.module.on-floor': 'A la planta',
  'client.reports.module': 'Mòdul',
  'widgets.type.date': 'Data',
  'widgets.type.apps-carousel': "Carrusel d'aplicacions",
  'widgets.type.apps-directory': "Directori d'aplicacions",
  'widgets.type.portfolio-summary': 'Resum del portfolio',
  'widgets.type.weather': 'Temps',
  'widgets.type.air-quality': "Qualitat de l'aire exterior",
  'widgets.type.metric': 'Mètrica',
  'widgets.type.app': 'Aplicació',
  'widgets.kind.url': 'Enllaç (url)',
  'widgets.kind.data': 'Dades (data)',
  'widgets.kind.custom': 'Propi (custom)',
  'widgets.kind.custom-app': 'Aplicació amb interfície pròpia',
  'widgets.behavior.link': 'Enllaç',
  'widgets.behavior.blueprint': 'Plànols',
  'widgets.behavior.reports': 'Informes',
  'widgets.behavior.contacts': 'Contactes',
  'widgets.behavior.contacts_download': 'Descàrrega de contactes',
  'widgets.behavior.cosbim': 'COSBIM',
  'widgets.behavior.ocas': 'OCAs',
  'widgets.behavior.assistant': 'Assistent',
  'widgets.config.behavior': 'Comportament',
  'widgets.config.node_types': "S'ofereix a",
  'widgets.config.required_permission': 'Permís requerit',
  'widgets.node_type.portfolio': 'Portfolio',
  'widgets.node_type.space': 'Espai o ciutat',
  'widgets.node_type.building': 'Edifici',
  'widgets.node_type.subbuilding': 'Subedifici',
  'widgets.node_type.client': 'Client',
  'widgets.public': 'Públic',
  'widgets.public.help':
    "Qualsevol usuari amb accés a l'entitat el veu, sense necessitar el permís del widget. S'ha d'assignar igualment a cada entitat.",
  'administration.ocas.filter.status.danger_warning': 'Dates en vermell i groc',
  'administration.ocas.docuware_pending':
    'La font de documents (DocuWare) està pendent de configurar: fins llavors les instal·lacions figuren com a «Pendent» i sense document.',
  'administration.ocas.building.no_document': 'Sense document',
  'administration.ocas.building.last_sync': 'Dades de DocuWare del',
  'administration.ocas.building.sync_error':
    "No s'ha pogut connectar amb DocuWare. Es mostren les últimes dades disponibles.",
  'administration.ocas.tittle.delete':
    'Esteu segur de voler esborrar aquesta instal·lació?',
  'administration.ocas.month': 'mes',
  'administration.ocas.months': 'mesos',
  'administration.ocas.building.status.not_applicable': 'N/A',
  'administration.ocas.date.not_applicable': 'N/A',
  'administration.ocas.date.pending': 'Pendent',
  'administration.ocas.building.status.pending': 'Pendent',
  'administration.settings.ocas.title': 'Avisos per correu de les OCA',
  'administration.settings.ocas.enabled': "Activar els avisos d'OCA",
  'administration.settings.ocas.expiry_days':
    "Dies d'antelació de l'avís de venciment",
  'administration.settings.ocas.periodicity_days': 'Dies entre avisos repetits',
  'administration.settings.ocas.help':
    "Amb els avisos activats, AiteaView envia diàriament un correu als FM per cada edifici amb inspeccions a punt de vèncer, i als FM i al tècnic de l'edifici quan hi ha inspeccions no aprovades.",
  'administration.settings.ocas.save': "Desar avisos d'OCA",
  'administration.settings.notification.ocas_updated':
    "Avisos d'OCA actualitzats correctament",
  /* aiteaview_end_trans */
  /* aiteaassistant_start_trans */
  'example.example': 'Exemple',
  'assistant.title': 'Aitea Assistant',
  'assistant.say.something': "Pregunta'm alguna cosa",
  'assistant.action.delete': 'Eliminar',
  'assistant.action.speaker': 'Connectar amb altaveu',
  'assistant.action.microphone': 'Connectar amb micròfon',
  'assistant.action.microphonestop': 'Pausar micròfon',
  'assistant.action.attach': 'Adjuntar documents',
  'assistant.action.alerts': 'Afegir alertes',
  'assistant.action.settings': 'Configuració',
  'assistant.action.logout': 'Tancar sessió',
  'assistant.menu': 'Assistant',
  'assistant.initial.message': 'Hola de nou',
  'assistant.greeting':
    "Hola, [name]. Sóc el teu Assistent, l'eina que permet accedir de forma àgil i senzilla a la informació clau del portfolio de Colonial, millorar els KPI de manteniment, estalviar temps en les gestions diàries i servir de suport per al control de qualitat del manteniment operatiu.",
  'assistant.file.download': 'Descarregar document sol·licitat',
  'assistant.file.error':
    "Error en descarregar l'arxiu. Els arxius només es poden descarregar una vegada. Per tornar-lo a visualitzar, cal sol·licitar-lo de nou.",
  'assistant.user.pronoun': 'Jo',
  'assistant.delete.disclaimer': 'Estàs segur que vols eliminar la conversa?',
  'assistant.delete.title': "Eliminar l'historial de la conversa",
  'assistant.yesterday': 'Ahir',
  'assistant.today': 'Avui',
  'assistant.thinking': 'Pensant...',
  'assistant.listening': 'Escoltant...',
  'assistant.playing': 'Reproduint...',
  'assistant.playback.speed': 'Velocitat de reproducció',
  'assistant.playback.close': 'Tancar reproductor',
  'assistant.finish': 'Finalitzar',
  'assistant.reasoning': 'Raonament',
  'assistant.feedback.title': 'Com ha estat aquesta resposta?',
  'assistant.feedback.comment.placeholder': 'Comentari (opcional)',
  'assistant.feedback.submit': 'Enviar',
  'permissions.global.assistant.use': "Utilitzar l'assistent",
  'permissions.global.assistant.use.description':
    "Preguntar a l'assistent i consultar l'historial de xats propi.",
  'permissions.global.assistant.chatbot': 'Assistent en mode xatbot',
  'permissions.global.assistant.chatbot.description':
    "Utilitzar l'assistent com a xatbot: respon a les preguntes.",
  'permissions.global.assistant.agentic': 'Assistent en mode agèntic',
  'permissions.global.assistant.agentic.description':
    "Utilitzar l'assistent en mode agèntic: a més de respondre, executa accions.",
  /* aiteaassistant_end_trans */
  /* dashboards_start_trans */
  'menu.dashboardList': 'Llista de quadres de comandament',
  'dashboard.name': 'Nom del Dashboard',
  'dashboard.description': 'Descripció del Dashboard',
  'dashboard.widgets': 'Widgets',
  'dashboard.widgets.chart-line': 'Gràfic de línies',
  'dashboard.widgets.chart-area': "Gràfic d'àrees",
  'dashboard.widgets.chart-column': 'Gràfic de columnes',
  'dashboard.widgets.table': 'Taula',
  'dashboard.widgets.counter': 'Comptador',
  'dashboard.widgets.title': 'Títol',
  'dashboard.widgets.text': 'Text',
  'dashboard.widgets.chart-abscissa': 'Gràfic d’abscisses',
  'dashboard.widgets.chart-pie': 'Gràfic de seccions',
  'dashboard.widgets.chart-bar-electric-use': 'Gràfica de barres %',
  'dashboard.widgets.electric-use.types': 'Dades a mostrar',
  'dashboard.widgets.electric-use.power': 'Força',
  'dashboard.widgets.electric-use.lighting': 'Enllumenat',
  'dashboard.widgets.electric-use.hvac': 'Clima',
  'dashboard.widgets.electric-use.validation-error':
    "Has de triar almenys un tipus de dada i l'agrupació de les dades.",
  'dashboard.widgets.electric-use.no-entity':
    "Aquest widget necessita obrir-se des d'un edifici, subedifici o client.",
  'dashboard.widgets.electric-use.no-module':
    "Aquesta entitat no té el mòdul Electricidad Uso amb l'agrupació triada.",
  'dashboard.widgets.create': 'Crear nou widget',
  'dashboard.widgets.name': 'Nom del widget',
  'dashboard.widgets.database': 'Base de dades',
  'dashboard.widgets.collector': 'col·lector',
  'dashboard.widgets.counter.type': 'Tipus de valor',
  'dashboard.widgets.counter.type.max': 'Valor màxim',
  'dashboard.widgets.counter.type.last': 'Darrer valor',
  'dashboard.widgets.content': 'Contingut del widget',
  'dashboard.widgets.content.edit': 'Editar contingut',
  'dashboard.widgets.save': 'Desar',
  'dashboard.widgets.delete': 'Esborra',
  'dashboard.widgets.cancel': 'Cancel·lar',
  'dashboard.widgets.add': 'Afegir',
  'dashboard.widgets.delete-confirmation': 'Segur que vols esborrar el widget?',
  'dashboard.widgets.close-confirmation':
    'Segur que vols sortir? Si tens canvis sense desar es perdran.',
  'dashboard.widgets.select': 'Selecciona el tipus de widget',
  'dashboard.widgets.select.columns': 'Màxim de columnes',
  'dashboard.widgets.select-type.electrical': 'Elèctric',
  'dashboard.widgets.select-type.water': 'Aigua',
  'dashboard.widgets.select-type.gas': 'Gas',
  'dashboard.widgets.select-type.thermal-cold': 'Tèrmic (fred)',
  'dashboard.widgets.select-type.thermal-hot': 'Tèrmic (calor)',
  'dashboard.widgets.select-type.thermal-total': 'Tèrmic total',
  'dashboard.widgets.select-type.temperature': 'Temperatura',
  'dashboard.widgets.select-type.ext-temperature': 'Temperatura Ext.',
  'dashboard.widgets.select-type.humidity': 'Humitat',
  'dashboard.widgets.select-type.ext-humidity': 'Humitat Ext.',
  'dashboard.widgets.select-type.co2': 'CO2',
  'dashboard.widgets.select-type.ext-co2': 'CO2 Ext.',
  'dashboard.widgets.select-type.cala': "Qualitat de l'aire",
  'dashboard.widgets.select-type.occupation-percentage':
    "Percentatge d'Ocupació",
  'dashboard.widgets.select-group.hourly': 'Horari',
  'dashboard.widgets.select-group.daily': 'Diari',
  'dashboard.widgets.select-group.monthly': 'Mensual',
  'dashboard.widgets.select-group.yearly': 'Anual',
  'dashboard.widgets.select-type.title-warning': "Avís de tipus d'agrupació",
  'dashboard.widgets.select-type.body-warning':
    'El tipus de dada que has seleccionat només conté dades per hora, el widget estarà buit.',
  'dashboard.widgets.date.from': 'Des de',
  'dashboard.widgets.date.to': 'Fins a',
  'dashboard.widgets.text.header': 'Giny de text',
  'dashboard.widgets.title.header': 'Giny de títol',
  'dashboard.widgets.module.title-error': 'Error del mòdul',
  'dashboard.widgets.module.body-error':
    'El col·lector {collectorType} {collectorGroupingType} del widget {widgetName} no existeix a {representName}.',
  'dashboard.widgets.multi.edit-chart': 'Edita el gràfic',
  'dashboard.widgets.multi.content': 'Creació de gràfic d’abscisses',
  'dashboard.widgets.multi.title': 'Títol',
  'dashboard.widgets.multi.footer': 'Peu de pàgina',
  'dashboard.widgets.multi.components': 'Components',
  'dashboard.widgets.multi.component': 'Component',
  'dashboard.widgets.multi.edit': 'Edita',
  'dashboard.widgets.multi.delete': 'Suprimeix',
  'dashboard.widgets.multi.edit-component': 'Edita el component',
  'dashboard.widgets.multi.component-name': 'Nom del component',
  'dashboard.widgets.multi.chart-type': 'Tipus de gràfic',
  'dashboard.widgets.multi.source': 'Font',
  'dashboard.widgets.multi.color': 'Color',
  'dashboard.widgets.multi.lines': 'Línies',
  'dashboard.widgets.multi.columns': 'Columnes',
  'dashboard.widgets.multi.line': 'Línia',
  'dashboard.widgets.multi.min': 'Mínim',
  'dashboard.widgets.multi.mean': 'Mitjana',
  'dashboard.widgets.multi.max': 'Màxim',
  'dashboard.widgets.multi.default': 'Per defecte',
  'dashboard.widgets.multi.stacked-percentage':
    'Gràfic apilat amb percentatges',
  'dashboard.widgets.multi.total-grouped':
    'Gràfic de totals agrupats per component',
  'dashboard.widgets.multi.last-year-compare': 'Comparar amb l’any anterior',
  'dashboard.widgets.donut.content': 'Creació de gràfic de seccions',
  'dashboard.widgets.collector-type': 'Tipus de dades',
  'dashboard.widgets.collector-grouping-type': 'Agrupació de dades',
  'dashboard.widgets.edi.template-warning':
    'Mode edició, aquest Dashboard és una plantilla d’informe, per veure les dades accediu-hi des d’EDI.',
  'dashboard.widgets.edi.template-error':
    'Aquest quadre de comandament és una plantilla d’informe, accedeix-hi des d’EDI per visualitzar les dades.',
  'dashboards.create-dashboard': 'Crear',
  'dashboards.create-button': 'Nou quadre de comandament',
  'dashboards.create-dashboard.title': 'Crear nou quadre de comandament',
  'dashboards.new-dashboard-name': 'Nom del quadre de comandament',
  'dashboards.modify-dashboard': 'Modificar',
  'dashboards.update-dashboard-name': 'Actualitzar nom',
  'dashboard.widgets.table.title': 'Taula',
  'dashboard.widgets.table.columns': 'Columnes',
  'dashboard.widgets.table.add.column': 'Afegir columna',
  'dashboard.widgets.table.rows': 'Files',
  'dashboard.widgets.table.add.row': 'Afegir fila',
  'dashboard.widgets.table.footer': 'Peu de pàgina',
  'dashboard.widgets.table.configure': 'Configurar',
  'dashboard.widgets.table.type': 'Tipus',
  'dashboard.widgets.table.type.horizontal': 'Horitzontal',
  'dashboard.widgets.table.type.vertical': 'Vertical',
  'dashboard.widgets.table.color.first.row': 'Color de la primera fila',
  'dashboard.widgets.table.color.other.rows': 'Color altres files',
  'dashboard.widgets.table.color.other.cols': 'Color altres Columnes',
  'dashboard.widgets.table.compare.hide.months': 'Amagar mesos',
  'dashboard.widgets.table.validation.stats-required':
    'Has de seleccionar almenys una opció a Altres files oa Altres columnes',
  'dashboard.widgets.table.color.conditioned': 'Color condicionat',
  'dashboard.widgets.table.condition': 'Condició',
  'dashboard.widgets.table.others.rows': 'Altres files',
  'dashboard.widgets.table.others.columns': 'Altres columnes',
  'dashboard.widgets.table.compare.last.year': 'Comparar amb l’any anterior',
  'dashboard.widgets.table.max': 'Màxim',
  'dashboard.widgets.table.minimun': 'Mínim',
  'dashboard.widgets.table.average': 'Mitjana',
  'dashboard.widgets.table.configuration': 'Configurar',
  'dashboard.widgets.table.title-placeholder': 'Títol',
  'dashboard.widgets.table.footer-placeholder': 'Peu',
  'dashboard.widgets.table.condition-placeholder':
    'Ex: valor > 27 || valor < 17',
  'dashboard.create.report_properties': "Propietats de l'informe",
  'dashboard.create.report_description': 'Descripció',
  'dashboard.create.report_format':
    "Afegir format d'informe (portada, índex, capçalera i peu de pàgina)",
  'dashboard.create.report_image1': 'Imatge 1 (dreta del peu de pàgina)',
  'dashboard.create.report_image2': 'Imatge 2 (dreta de l’encapçalament)',
  'dashboard.create.report_image3': 'Imatge 3 (centre de la portada)',
  'dashboard.report-image.low-resolution.title': 'Resolució d’imatge baixa',
  'dashboard.report-image.low-resolution.body':
    'La resolució de la imatge seleccionada és inferior a la recomanada i pot afectar la seva qualitat de visualització a l’informe. Es recomana utilitzar una imatge de més resolució.',
  'dashboard.create.report_clients': 'Visible per a clients',
  'dashboard.create.report_disclaimer': 'Text Disclaimer',
  'dashboard.pdf': 'PDF',
  'dashboard.generate.pdf': 'Generar',
  'dashboard.mail': 'Mail',
  'dashboard.send.mail': 'Enviar',
  'dashboard.send_mail': 'Enviar al meu correu',
  'dashboard.close': 'Tancar',
  'dashboard.create.add_cover_page': 'Afegir portada',
  'dashboard.create.add_index_page': 'Afegir índex',
  'dashboard.create.add_header': 'Afegir capçalera',
  'dashboard.create.add_footer': 'Afegir peu de pàgina',
  'dashboard.create.report_disclaimer_two': 'Text Disclaimer 2',
  'dashboard.title.data.quality': 'Qualitat de la dada',
  'dashboard.title.forced.points': 'Punts en forçat manual',
  'dashboard.title.points.outside.rite': 'Punts fora del RITE',
  'dashboard.title.vrvs.alarms': 'VRVs amb alarma de filtre',
  'dashboard.title.data.frequency':
    'Anàlisi de la freqüència de recollida de la dada',
  'dashboard.title.abnormal.electrical.electrical': 'Consums elèctrics anòmals',
  'dashboard.title.startup.recommendation': 'Recomanació d’engegada',
  'dashboard.create.corporate_text': 'Text corporatiu',
  'dashboard.dashboards.delete-confirmation':
    'Segur que voleu esborrar aquest informe?',
  'dashboard.save.success': "El quadre de comandament s'ha desat correctament.",
  'dashboard.table.total': 'Total',
  'dashboard.table.total.accumulated': 'Total Acumulat',
  'dashboard.table.min': 'Mínim',
  'dashboard.table.avg': 'Mitjana',
  'dashboard.table.stat': 'Estadística',
  'dashboard.table.year': 'Any',
  'dashboard.table.month': 'Mes',
  'dashboard.table.value': 'Valor',
  'dashboard.table.floor': 'Planta',
  'dashboard.table.module': 'Mòdul',
  'dashboard.month.short.jan': 'Gen',
  'dashboard.month.short.feb': 'Feb',
  'dashboard.month.short.mar': 'Mar',
  'dashboard.month.short.apr': 'Abr',
  'dashboard.month.short.may': 'Mai',
  'dashboard.month.short.jun': 'Jun',
  'dashboard.month.short.jul': 'Jul',
  'dashboard.month.short.aug': 'Ago',
  'dashboard.month.short.sep': 'Set',
  'dashboard.month.short.oct': 'Oct',
  'dashboard.month.short.nov': 'Nov',
  'dashboard.month.short.dec': 'Des',
  'dashboard.level.title1': 'Títol 1',
  'dashboard.level.title1_1': 'Títol 1.1',
  'dashboard.level.title1_1_1': 'Títol 1.1.1',
  'dashboard.level.title1_1_1_1': 'Títol 1.1.1.1',
  'dashboard.level.title1_1_1_1_1': 'Títol 1.1.1.1.1',
  'dashboard.level.title1_1_1_1_1_1': 'Títol 1.1.1.1.1.1',
  'dashboard.groupType.building': 'Edifici',
  'dashboard.groupType.client': 'Client',
  'dashboard.groupType.subbuilding': 'Sub Edifici',
  'dashboard.groupType.spaces': 'Ciutat',
  'dashboard.groupType.portfolio': 'Portfolio',
  'dashboard.upload.select-image': 'Selecciona imatge',
  'dashboard.date.range.warning':
    'No es poden generar informes amb més d’un any seleccionat en el rang de dates.',
  'electric.consumption': 'Consum elèctric',
  'water.cons': "Consum d'aigua",
  'gas.cons': 'Consum de gas',
  'districlima.cons': 'Consum tèrmic (total)',
  'chart.temp': 'Temperatura',
  'districlima.cons.cold': 'Consum tèrmic (fred)',
  'districlima.cons.hot': 'Consum tèrmic (calor)',
  'chart.humid': 'Humitat',
  'chart.humid.ext': 'Humitat ext.',
  'metric.occup': 'Percentatge d’ocupació',
  'temp.ext': 'Temperatura ext.',
  'dashboard.generator': 'Generador d’informes',
  'dashboard.report.headless.loading': "Carregant les dades de l'informe...",
  'dashboard.report.headless.rendering': "Generant els gràfics de l'informe...",
  'dashboard.report.headless.generating': "Creant el PDF de l'informe...",
  'dashboard.report.headless.done': 'Informe generat.',
  'dashboard.report.headless.timeout-error':
    "S'ha superat el temps màxim d'espera en generar l'informe. Torna-ho a provar o redueix el rang de dates.",
  'dashboard.report.headless.error':
    "No s'ha pogut generar el PDF de l'informe.",
  'dashboard.widgets.image': 'Imatge',
  'dashboard.widgets.image.empty': 'Aquest widget no té imatge.',
  'dashboard.widgets.image.file': 'Imatge del widget',
  'dashboard.widgets.image.help':
    "JPEG, PNG, WebP o GIF, fins a 5 MB. S'ajusta a la mida del widget sense deformar-se.",
  'dashboard.widgets.image.invalid-type':
    'Format no admès. Fes servir JPEG, PNG, WebP o GIF.',
  'dashboard.widgets.image.too-large':
    'La imatge supera la mida màxima de 5 MB.',
  'dashboard.widgets.image.required': 'Selecciona una imatge.',
  /* dashboards_end_trans */
};
